
export function page2Link(id: string): string {
    return `${window.location.protocol}//${window.location.host}/invitation/p/${id}`
}

export function share2Link(id: string): string {
    return `${window.location.protocol}//${window.location.host}/s/${id}`
}